<script setup lang="ts">
import type { CustomerDetailsKid } from '@entities/customer'

import { faChevronDown } from '@fortawesome/pro-regular-svg-icons'

import { KidBalanceItem } from '@shared/ui/cards'
import { LinkTextPrimaryMedium } from '@shared/ui/links'
import { BtnIcon } from '@shared/ui/buttons'

import { useCustomerBalance } from '../model/customer-balance.hook'

defineOptions({
  name: 'CustomerKidBalance',
})

defineProps<{
  kid: CustomerDetailsKid
}>()

const {
  getKidUrl,
  getDisciplineUrl,
  getDisciplineName,
  getGeneralRows,
  getExtendedRows,
} = useCustomerBalance()

const refIsOpen = ref<boolean>(false)

const toggle = (): void => {
  refIsOpen.value = !refIsOpen.value
}
</script>

<template>
  <div class="customer-kid-balance">
    <div class="customer-kid-balance__head">
      <LinkTextPrimaryMedium :href="getKidUrl(kid.id)">
        {{ kid.name }}
      </LinkTextPrimaryMedium>
      <BtnIcon
        :icon="faChevronDown"
        view="transparent"
        :class="['customer-kid-balance__toggle', { 'customer-kid-balance__toggle--open': refIsOpen }]"
        @click="toggle"
      />
    </div>
    <div class="customer-kid-balance__main">
      <div
        v-for="discipline in kid.disciplines"
        :key="discipline.id"
        class="customer-kid-balance__discipline"
      >
        <div class="customer-kid-balance__discipline-head">
          <LinkTextPrimaryMedium :href="getDisciplineUrl(discipline.id)">
            {{ getDisciplineName(discipline.code) }}
          </LinkTextPrimaryMedium>
          <div class="customer-kid-balance__group">
            <KidBalanceItem
              v-for="row in getGeneralRows(discipline)"
              :key="row.label"
              :label="row.label"
              :value="row.value"
              :tooltip="row.tooltip"
            />
          </div>
        </div>
        <div
          v-if="refIsOpen"
          class="customer-kid-balance__group"
        >
          <KidBalanceItem
            v-for="row in getExtendedRows(discipline)"
            :key="row.label"
            :label="row.label"
            :value="row.value"
            :tooltip="row.tooltip"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./CustomerKidBalance.scss" />
